import React from 'react';
import { Stack } from '@mui/material';
import FormattedText from './FormattedText';
import MessageDocumentCard from './MessageDocumentCard';
import useMessageStyles from '../../../hooks/useMessageStyles';

export default function DocumentMessage({ message }) {
  const { messageCaptionSx, messageRichStackSx } = useMessageStyles();
  const media = message.media || {};
  const fileName = media.fileName || message.text || 'Document';
  const fileUrl = media.url;
  const caption = media.caption || message.text;

  return (
    <Stack spacing={0.75} sx={messageRichStackSx}>
      <MessageDocumentCard fileName={fileName} fileUrl={fileUrl} />

      {caption && caption !== fileName && (
        <FormattedText text={caption} sx={messageCaptionSx} />
      )}
    </Stack>
  );
}
